document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.anim').forEach(el => {
    const listener = () => {
      if(el){
        const {top, bottom} = el.getBoundingClientRect();
        if(top < window.innerHeight * 0.9 && bottom > 0){
          el.classList.add('animate');
        } else if (top >= window.innerHeight) {
          el.classList.remove('animate');
        }
      }
    }
    listener();
    window.addEventListener('scroll', listener);
    window.addEventListener('resize', listener);
  });
});

document.addEventListener('DOMContentLoaded', () => {
  window.addEventListener('click', (event) => {
    const button = event.target.closest('.swym-add-to-cart-btn');
    if (button) {
      if (button.getAttribute('aria-label') === 'Added To Cart') {
        window.location.href = '/cart';
        return;
      }
      const observer = new MutationObserver((mutations) => {
        mutations.forEach(mutation => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'aria-label') {
            if (button.getAttribute('aria-label') === 'Added To Cart') {
              observer.disconnect();
              window.location.href = '/cart';
            }
          }
        });
      });

      observer.observe(button, { attributes: true });
    }
  }, {capture: true});
});

document.addEventListener('DOMContentLoaded', () => {
  const moreDetailsObserver = new MutationObserver((mutations) => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          const el = node.matches('a.swym-more-details-btn') ? node : node.querySelector('a.swym-more-details-btn')
          if(el){
            document.body.style.opacity = 0
            window.location.href = el.getAttribute('href');
          }
        }
      });
    });
  });

  moreDetailsObserver.observe(document.body, { childList: true, subtree: true });
});

document.addEventListener('DOMContentLoaded', () => {
  const replaceTable = {
    'Select a state/province...': '選択してください',
    'Year': '年',
    'Month': '月',
    'Day': '日'
  }
  new MutationObserver((mutations) => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1 && node instanceof Element) {
          Object.entries(replaceTable).forEach(([from, to]) => {
            const selector = `*[placeholder="${from}"]`
            const elements = node.matches(selector) ? [node] : node.querySelectorAll(selector)
            elements.forEach(el => {
              el.setAttribute('placeholder', to)
              if(el instanceof HTMLSelectElement){
                console.log(el.firstChild)
                el.firstChild.innerHTML = to
              }
            })
          })
        }
      })
    })
  }).observe(document.body, { childList: true, subtree: true })
})